module.exports = __webpack_public_path__ + "img/2025-01-09d_2.6dab0d31.jpg";